import { getUploadValidationsWithIssues } from '../../../helpers/uploadValidation';
import { UploadData } from '../../../../../../store/uploadStore';
import { stylesheet } from 'typestyle';
import { getIndividualValidationStatus } from '../../../helpers/individualValidation';
import { ValidationCheck } from '../../../../../../consts/validationCheck';
import { IndividualValidationStatus } from '../../../../../../consts/individualValidationStatus';
import { Blue80, ButtonIcon, Gray100, Red80, Tooltip, typeCompact14MediumProperties } from '@traceair/tds';
import { DownloadIcon, InfoIcon } from '@traceair/webapp-icons';
import React from 'react';
import { useDownloadValidationIssues } from './useDownloadValidationIssues';
import { getValidationError } from './getValidationError';
import { ProjectData } from '../../../types';

const css = stylesheet({
  container: {
    marginTop: 14,
  },
  validations: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 12,
  },
  warning: {
    color: Gray100,
  },
  error: {
    color: Red80,
  },
  title: {
    ...typeCompact14MediumProperties,
  },
  noteIcon: {
    verticalAlign: -6,
    margin: '-5px 0 -5px 2px',
  },
  download: {
    textDecoration: 'none',
    color: Blue80,
    ...typeCompact14MediumProperties,
    $nest: {
      '&:hover:not(:active), &:focus:not(:active)': {
        opacity: 0.8,
      },
    },
  },
  downloadIcon: {
    marginRight: 4,
    verticalAlign: -3,
  },
});

interface Props extends ProjectData {
  upload: UploadData;
}

export const FlightValidationIssueList = ({ customer, site, upload }: Props) => {
  const unsuccessfulUploadValidations = getUploadValidationsWithIssues(upload);
  const handleDownloadFlaggedPhoto = useDownloadValidationIssues(customer, site, upload, unsuccessfulUploadValidations);

  if (!Object.values(unsuccessfulUploadValidations).length) {
    return null;
  }

  return (
    <div className={css.container}>
      <div className={css.validations}>
        {Object.entries(unsuccessfulUploadValidations).map(([validation, data]) => {
          const status = getIndividualValidationStatus(validation as ValidationCheck, false);
          const className = status === IndividualValidationStatus.Warning ? css.warning : css.error;
          const { title, note } = getValidationError(validation as ValidationCheck);

          return (
            <div key={validation} className={className}>
              <div className={css.title}>
                {data.count} photos: {title}
                <Tooltip arrow description={note} offset={4} placement="top" styleType="neutral-high" trigger="hover">
                  <ButtonIcon
                    className={css.noteIcon}
                    style={'tertiary'}
                    icon={<InfoIcon color={status === IndividualValidationStatus.Warning ? Gray100 : Red80} />}
                    size="xs"
                  />
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>

      <a href="#" onClick={handleDownloadFlaggedPhoto} className={css.download}>
        <span className={css.downloadIcon}>
          <DownloadIcon size={16} color={Blue80} />
        </span>
        Download validation issues
      </a>
    </div>
  );
};
